import { endOfDay, max as maxDate, startOfDay } from 'date-fns'
import { useFormContext, useWatch } from 'react-hook-form'

import {
  BIDS_PER_JOB_ANALYSIS_EARLIEST_DATE,
  BidsPerJobAnalysisPeriod,
  resolveMetricsPeriod,
} from 'components/reports/Metrics/constants'
import { BidsPerJobAnalysisInputDtoInput } from 'generated/graphql'

import { BidsPerJobAnalysisFilterValues } from './BidsPerJobAnalysisFilterCriteria'

interface QueryInput {
  start: Date | null
  end: Date | null
  hasValidRange: boolean
  isCustom: boolean
  input: BidsPerJobAnalysisInputDtoInput
}

export const useBidsPerJobAnalysisQueryInput = (): QueryInput => {
  const { control } = useFormContext<BidsPerJobAnalysisFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const selectedServiceCodes = useWatch({ control, name: 'selectedServiceCodes' })
  const vehicleType = useWatch({ control, name: 'vehicleType' })

  const isCustom = period === ('custom' as BidsPerJobAnalysisPeriod)
  const hasCompleteCustomRange = isCustom && customStart != null && customEnd != null

  const { start: rawStart, end } = hasCompleteCustomRange
    ? { start: startOfDay(customStart), end: endOfDay(customEnd) }
    : resolveMetricsPeriod(period)

  const start = rawStart ? maxDate([rawStart, BIDS_PER_JOB_ANALYSIS_EARLIEST_DATE]) : null

  const hasValidRange = start != null && end != null && start <= end

  return {
    start,
    end,
    hasValidRange,
    isCustom,
    input: {
      start: start ?? new Date(),
      end: end ?? new Date(),
      xeroCodeIds: selectedServiceCodes?.length
        ? selectedServiceCodes.map((option) => option.value)
        : null,
      vehicleType,
    },
  }
}
